
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { HubTemplateSaveModalComponent } from './template-save-modal.component';
import { DialogTemplateComponent } from '../dialog-template/dialog-template.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    MessageModule,
    DialogTemplateComponent,
  ],
  exports: [HubTemplateSaveModalComponent],
  declarations: [HubTemplateSaveModalComponent],
})

export class HubTemplateSaveModalModule { }
